import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const PUPPY_SILHOUETTE = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80.2 103.5"
    className="mw-100 max-h-100"
  >
    <path
      fill="currentColor"
      d="M80.11 79.1a27 27 0 0 0-1.27-10.46c-1.61-6.08-5.93-11.32-10.65-13.29-1.39-.59-3.14-1.42-5-2.39-2.81-1.46-5.9-3.22-8.51-4.92l-1.25-.84c-1-.7-1.91-1.37-2.65-2a10.54 10.54 0 0 1-1.68-1.68c-3.13-4.31-5.33-7.8-6.53-9.8-.73-1.21-1.09-1.88-1.09-1.88l.3-2c0-.41.12-.86.18-1.34.17-1.2.35-2.58.51-3.89.09-.78.17-1.54.24-2.22A16.08 16.08 0 0 0 41 13.5a10 10 0 0 0 2.8 2.18c4.59 2.21 8.62-.5 9.1-3S47.72 2.8 44.5 1.39C42.62.57 37 3.14 32.77 5.4a19.83 19.83 0 0 0-9.1-2.26 18.7 18.7 0 0 0-6.28 1.08l-.83.31-.22.1c-2.6-2.42-5.62-4.81-7-4.62C6.41.38.23 4.79 0 7s2.37 5.23 6.53 4.55a6.84 6.84 0 0 0 1.85-.62 15.34 15.34 0 0 0-2.32 4.13c-.12.29-.22.57-.32.86s-.2.58-.29.87c-.17.59-.32 1.19-.44 1.8a18.76 18.76 0 0 0-.37 3.77v1.88a2 2 0 0 0 0 .25v.24a.59.59 0 0 0 0 .13v.39a2.17 2.17 0 0 0 0 .25v.21c0 .23.09.47.13.69q.07.34.15.66v.19c0 .06.08.33.13.49l.06.2c0 .17.09.33.14.49l.06.17c.06.2.12.4.19.6.3.87.62 1.76 1 2.7 0 .12.08.24.13.36a6.34 6.34 0 0 0-.9 1.21c-3.68 6.38 2.56 9.42 7 9.53h2a.11.11 0 0 0 .07 0l.44.48a1.7 1.7 0 0 1 0 .22 1.94 1.94 0 0 1 0 .24 5.66 5.66 0 0 1-.17 1.38l-.06.21c-.14.48-.33 1-.53 1.52-.51 1.47-1.09 3.59-1.09 8.25v.78c0 .26 0 .52.05.78 0 1.69 2.41 18.19 3.47 26.34a33.43 33.43 0 0 1 .46 4.5c-2.88 0-5.84.94-6.62 3a2.9 2.9 0 0 0-.12.42 2.93 2.93 0 0 0 0 1.45c.51 1.73 3.06 2 5.55 2a17.26 17.26 0 0 0 4.79-1.42c1.26-.51 2.24-1 2.24-1s.22-.91.5-2.39c.15-.74.3-1.61.46-2.59 0-.24.07-.49.11-.74.11-.77.22-1.58.32-2.42s.22-1.83.37-2.95c.25-1.88.56-4.06.85-6.18l.75.38.17.08.76.35h.05l.77.31h.11c.27.11.55.21.83.3.59.19 1.19.35 1.8.49.45.1.91.18 1.38.25v.46c0 2.34 1.18 13.17 3 19.09-3.06 0-5.28 2.08-5.53 3.56-.62 3.73 2.56 3.19 5.66 3.19s5.88-1.19 6.22-3.19c.1-.63 1.25-6.68 2.39-12.79l.37.34.33.29.89.79.44.38c.21.19.36.32.43.37l.78.58c.25.18.52.36.78.53h.05c.26.17.52.33.79.48h.07l.78.42H50l.77.37.14.06.76.31.17.07.75.26.21.07.72.22.25.07.71.17H54.77l.69.13.31.06c.23 0 .47.06.7.09h.33c.24 0 .48 0 .73.06h.06c-.77.39-1.54.8-2.23 1.2a17.73 17.73 0 0 0-2.22 1.43c-.12.1-.23.19-.32.28a3.33 3.33 0 0 0-.46.59 5.76 5.76 0 0 0-.65 1.47c-.08.26-.15.53-.21.8a2.93 2.93 0 0 0 .46 2.32 2.74 2.74 0 0 0 .39.45l.11.08a3 3 0 0 0 .63.41 2.91 2.91 0 0 0 .89.29q.76.1 1.62.18a13.57 13.57 0 0 0 4.07-.18 5.86 5.86 0 0 0 .67-.21 20.08 20.08 0 0 0 4.28-2.68c2.38-1.01 3.78-2.34 3.78-2.34l3.08-2.27 2.27-1.67c2.55-1.89 4-3.5 5-6.1a16 16 0 0 0 1.36-8.43z"
    />
  </svg>
);

const DOG_SILHOUETTE = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 153.39 172.31"
    className="mw-100 max-h-100"
  >
    <path
      fill="currentColor"
      d="M152.7 88.83h-.46a40 40 0 0 1-38.52-19.75c-.13-.27-.27-.54-.41-.81-4.86-9-18.23-15.43-34-15.56h-.49c-1.67 0-3.32.08-4.94.22-16.77 0-22.6-7-24.11-9.4l3.77-10.43A14.12 14.12 0 0 0 54 25l.29.15c4.28 2.06 10.26 2.27 13 .58 1.94-1.19 1.24-3.77 1.56-5.47.79-4.19-8.25-15.69-13.38-18-2.5-1.09-9.13 1.55-15.15 4.54a14.06 14.06 0 0 0-4.67-.8h-7.84a14.37 14.37 0 0 0-3.54.45C21.93 3.12 19.53.33 17.83.08 13.18-.62 1.62 3.51.31 6.83S1.68 16 8.45 16.8a14.88 14.88 0 0 0 5.41-.65l-2.93 5.07a14.08 14.08 0 0 0-1 11.88l.3.81c-.94.66-3.25 7.22-.93 12.84 1.42 3.43 5 9 10.53 9.35.53 1.82.83 2.59.47 3.65-2 6-1.18 23.89 4 35 7 15 13 65 13 65a29.92 29.92 0 0 0-5 2c-2 1-4.85 3.44-4 6s3.36 3.62 7.52 3a41 41 0 0 0 11.48-3s-1-40-1.19-52.62c3.3.74 4.28 1.19 8.83.88.76 10.13 4.74 36.09 6.34 44.76 0 0-11 3-8 10 .91 2.12 6.94 1.68 11 1 6-1 7-5 7-5 0-29 1.6-39.91.51-54.25.53-.21 1.06-.43 1.59-.67.39 1.71 3.9 9.92 13.4 17.84 4 3.36 2.09 21.65 2.09 21.65l-3.59 1.76c-2.35 1.16-4.9 4.58-3 6.34 2.52 2.28 14.4 1.69 15-1.67 1-6 2-24 1.4-27.37-.69-3.82-3.83-10.44-4.4-14.63a27.71 27.71 0 0 1 2.15-12.3c.67 8.06.94 11.27 1.85 14.3 3 10 7 12 10 21 1 3 2.92 8.54 3 13 0 1.74 0 7-1.47 7.95-1.78 1.13-5.2 3.79-4.53 6.05.82 2.72 10.43 1.85 11.46.95l2.63-2.3a4.18 4.18 0 0 0 1.42-3.71c-.76-5.93-2.73-20.27-2.67-29.57a213.57 213.57 0 0 1 1.77-23.8A112.15 112.15 0 0 0 119.6 87a40 40 0 0 0 33.4 3 .62.62 0 0 0-.3-1.17z"
    />
  </svg>
);

const DOG_SILHOUETTE_ICON = (
  <svg
    viewBox="0 0 72 72"
    xmlns="http://www.w3.org/2000/svg"
    className="mw-100 max-h-100"
  >
    <rect width="72" height="72" rx="36" fill="#FAFAFA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.9512 20.8589C46.1637 22.4454 47.9178 25.0183 48.9262 28.7111C50.5377 34.612 49.9313 38.5953 48.7649 41.1744C48.6196 41.4957 48.4666 41.7927 48.3099 42.0667C48.9247 43.414 50.5633 45.9755 53.0477 47.3062C53.7218 47.6673 53.9755 48.5065 53.6144 49.1805C53.2534 49.8546 52.4142 50.1084 51.7401 49.7473C49.2001 48.3867 47.4243 46.1298 46.4109 44.399C46.3238 44.4723 46.2436 44.5361 46.1718 44.5907C46.0744 44.6648 45.9922 44.7223 45.929 44.7643C45.8974 44.7853 45.8705 44.8025 45.8488 44.8161L45.8202 44.8337L45.8089 44.8404L45.8041 44.8433L45.8018 44.8446C45.8008 44.8453 45.7997 44.8459 45.0999 43.6511L45.7997 44.8459C45.6373 44.941 45.4573 45.002 45.2705 45.0252C43.0584 45.2998 41.2722 44.7593 39.9552 43.5457C38.6908 42.3806 38.0189 40.741 37.6677 39.1061C36.9679 35.8483 37.41 31.9762 37.836 29.7115C37.9773 28.96 38.7011 28.4654 39.4527 28.6067C40.2042 28.7481 40.6988 29.4719 40.5575 30.2234C40.1526 32.3761 39.7925 35.8118 40.3752 38.5245C40.6652 39.8749 41.1557 40.8862 41.8317 41.5092C42.4083 42.0404 43.249 42.4094 44.5912 42.3107C44.6834 42.2348 44.8014 42.1301 44.9359 41.9933C45.3086 41.6141 45.8112 40.9851 46.2417 40.0333C47.0926 38.1518 47.7314 34.8475 46.2548 29.4407L46.2548 29.4406C45.3768 26.2253 43.9293 24.2508 42.3375 23.1093C40.7439 21.9666 38.8815 21.569 37.0089 21.7301L36.9991 21.7309L36.9991 21.7309L33.2088 22.0297L33.1917 22.0311L33.1917 22.031C31.1615 22.1658 30.1788 23.0288 29.6676 23.8998C29.1043 24.8597 29.0304 25.9837 29.1279 26.5969C29.2279 27.225 28.8872 27.8403 28.3019 28.0889L26.1635 28.9973C26.3856 30.3176 25.9525 31.6966 25.2595 32.7593C24.5818 33.7986 23.5463 34.7246 22.2643 35.221C22.674 35.932 23.1662 36.4807 23.7377 36.8318C24.3095 37.183 25.0378 37.3852 26.0159 37.2741C28.5378 36.9874 30.1872 36.7391 31.2172 36.5486C31.7337 36.453 32.0791 36.3748 32.2933 36.3176C32.369 36.2974 32.4202 36.2819 32.4518 36.2716C32.7771 36.0993 33.161 36.0622 33.5177 36.1751C33.9436 36.3098 34.2783 36.6418 34.4166 37.0666C35.004 38.8712 35.1356 41.2566 34.798 43.718C34.5368 45.622 33.9865 47.6351 33.0927 49.5369C35.2355 49.851 38.2829 49.8177 41.0575 48.5739C41.7553 48.2611 42.5746 48.5732 42.8874 49.271C43.2002 49.9688 42.8881 50.788 42.1903 51.1008C37.7783 53.0786 32.9617 52.5367 30.6065 51.8249C30.1964 51.7009 29.8667 51.394 29.7137 50.9938C29.5607 50.5935 29.6017 50.1449 29.8247 49.779C31.0361 47.7909 31.758 45.5029 32.0544 43.3417C32.2667 41.7946 32.2538 40.3664 32.077 39.2035C31.965 39.2257 31.8464 39.2484 31.7209 39.2716C30.6052 39.478 28.887 39.7348 26.3286 40.0256L26.3285 40.0256C24.7664 40.2031 23.4129 39.8821 22.2884 39.1915C21.1845 38.5135 20.381 37.5293 19.8019 36.4926C18.6588 34.4462 18.2605 31.9659 18.2211 30.3117C18.2076 29.7444 18.5416 29.2262 19.064 29.0043L26.3251 25.9199C26.3504 24.8886 26.6065 23.6445 27.2794 22.4981C28.2716 20.8076 30.0951 19.4637 32.9994 19.2684L36.7767 18.9706C39.1995 18.7633 41.742 19.2747 43.9512 20.8589ZM21.2943 32.6253C21.9578 32.3607 22.5373 31.8641 22.9399 31.2467C23.1893 30.8641 23.335 30.4979 23.4028 30.17L21.0516 31.1687C21.1011 31.6299 21.1804 32.1244 21.2943 32.6253ZM34.4942 27.5693C34.4942 26.8046 33.8743 26.1847 33.1096 26.1847C32.3449 26.1847 31.725 26.8046 31.725 27.5693V27.5877C31.725 28.3524 32.3449 28.9724 33.1096 28.9724C33.8743 28.9724 34.4942 28.3524 34.4942 27.5877V27.5693Z"
      fill="#4B4B4D"
    />
  </svg>
);

const PUPPY_SILHOUETTE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    className="mw-100 max-h-100"
  >
    <defs>
      <circle id="PUPPY_SILHOUETTE_ICON" cx="20" cy="20" r="20" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PUPPY_SILHOUETTE_ICON--mask" fill="#fff">
        <use href="#PUPPY_SILHOUETTE_ICON" />
      </mask>
      <use fill="#E6E6EB" href="#PUPPY_SILHOUETTE_ICON" />
      <path
        fill="#040416"
        fillOpacity=".2"
        d="M13.752 18.569c-.39 2.854-.773 5.361-.586 6.005.421 1.44 1.247 2.18 1.568 2.838.014.028.026.056.038.083.052.117.128.275.072.63a1.043 1.043 0 0 1-.024.104c-.36 1.408-2.765 4.49-3.573 5.606a46.28 46.28 0 0 0-.973 1.394c-1.684 2.524-2.276 4.217-2.149 6.813L9.38 52.807l22.408-.281.09-10.484c.15-3.047-.694-4.845-3.124-8.207-.808-1.116-3.214-4.198-3.573-5.606-.01-.036-.018-.07-.024-.105-.056-.354.02-.512.072-.63l.038-.082c.321-.657 1.146-1.397 1.568-2.838.187-.644-.195-3.151-.587-6.005.566 1.594 1.253 2.181 2.914 2.523.44.02.824-.261.943-.882.443-2.322 2.46-2.981 1.744-5.217-.562-1.757-1.412-1.904-2.618-2.131a15.338 15.338 0 0 1-1.1-.255c-1.177-.37-3.406-1.483-4.97-1.6-.832-.062-2.538.306-3.16.313-.622-.007-2.276-.326-3.235-.313-1.408.019-3.718 1.23-4.896 1.6-.371.1-.74.187-1.099.255-1.206.227-2.056.374-2.618 2.131-.715 2.236 1.3 2.895 1.745 5.217.118.62.502.903.942.882.404.02 2.349-.929 2.913-2.523z"
        mask="url(#PUPPY_SILHOUETTE_ICON--mask)"
      />
    </g>
  </svg>
);

const PUPPY_ICON_RECT = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 48"
    className="mw-100 max-h-100"
  >
    <defs>
      <rect id="PUPPY_ICON_RECT" x="0" y="0" width="72" height="48" rx="3" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PUPPY_ICON_RECT--mask" fill="#fff">
        <use href="#PUPPY_ICON_RECT" />
      </mask>
      <use fill="#E6E6EB" href="#PUPPY_ICON_RECT" />
      <path
        fill="#040416"
        fillOpacity=".2"
        d="M27.15 22.862c-.555 4.096-1.097 7.695-.831 8.619.597 2.068 1.766 3.13 2.221 4.073.02.04.036.08.054.119.074.168.181.394.101.903-.007.049-.02.098-.034.15-.509 2.02-3.917 6.445-5.061 8.046a66.442 66.442 0 00-1.379 2c-2.385 3.623-3.224 6.052-3.044 9.778L20.953 72l31.746-.404.126-15.046c.212-4.372-.982-6.953-4.426-11.778-1.143-1.601-4.551-6.025-5.061-8.045-.013-.053-.026-.102-.033-.15-.08-.51.028-.736.101-.904l.054-.119c.455-.943 1.624-2.005 2.221-4.073.266-.924-.276-4.523-.83-8.619.8 2.289 1.774 3.13 4.127 3.621.623.03 1.167-.374 1.336-1.265.628-3.333 3.484-4.279 2.47-7.487-.796-2.522-2-2.734-3.708-3.059a21.492 21.492 0 01-1.557-.365c-1.669-.53-4.827-2.129-7.041-2.297-1.18-.089-3.597.44-4.477.45-.883-.01-3.225-.468-4.584-.45-1.994.027-5.267 1.766-6.936 2.297-.525.142-1.049.268-1.557.365-1.708.325-2.912.537-3.709 3.059-1.013 3.208 1.843 4.154 2.472 7.487.168.89.712 1.295 1.335 1.265.572.03 3.327-1.332 4.127-3.62z"
        mask="url(#PUPPY_ICON_RECT--mask)"
      />
    </g>
  </svg>
);

/** @param {any} props */
export default function DogPlaceholderSvg({
  puppy = false,
  icon = false,
  rect = false,
  className = null,
  minWidth = null,
  minHeight = null,
  width = null,
  height = null
}) {
  return (
    <div
      className={classnames(
        'DogPlaceholderSvg relative dib v-top f0 moon-gray tc',
        className
      )}
      style={{
        width,
        height,
        minWidth,
        minHeight
      }}
    >
      <div
        className={classnames('w-100 transform-center', {
          'h-60': puppy && !icon && !rect,
          'h-50': !puppy && !icon && !rect
        })}
      >
        {(() => {
          if (rect) {
            return PUPPY_ICON_RECT;
          }
          if (icon) {
            return puppy ? PUPPY_SILHOUETTE_ICON : DOG_SILHOUETTE_ICON;
          }

          return puppy ? PUPPY_SILHOUETTE : DOG_SILHOUETTE;
        })()}
      </div>
    </div>
  );
}

DogPlaceholderSvg.propTypes = {
  icon: PropTypes.bool,
  puppy: PropTypes.bool,
  rect: PropTypes.bool,
  className: PropTypes.string,
  minWidth: PropTypes.string,
  minHeight: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};
